"use client";

import React, { useState } from "react";
import { useRouter } from "next/navigation";
import { sendAdminOtpAction, verifyAdminOtpAction } from "@/lib/actions/admin.auth.actions";
import { useAdminAuthStore } from "@/store/useAdminAuthStore";

export default function AdminLoginContent() {
  const router = useRouter();
  const setAuth = useAdminAuthStore((s) => s.setAuth);

  const [step, setStep] = useState<"phone" | "otp">("phone");
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [devCode, setDevCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSendOtp = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await sendAdminOtpAction(phone);
    setLoading(false);
    
    if (res.success) {
      setDevCode(res.devCode || "");
      setStep("otp");
    } else {
      setError(res.error || "خطا در ارسال پیامک");
    }
  };

  const handleVerifyOtp = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await verifyAdminOtpAction(phone, code);
    setLoading(false);
    
    if (res.success && res.admin) {
      setAuth(res.admin);
      router.replace("/"); // بعد از ورود موفق به داشبورد می‌رود
    } else {
      setError(res.error || "کد اشتباه است");
    }
  };

  return (
    <div style={{ maxWidth: "400px", margin: "100px auto", textAlign: "center", direction: "rtl", fontFamily: "Tahoma, sans-serif" }}>
      <h2 style={{ marginBottom: "20px" }}>تست عملیاتی ورود ادمین</h2>
      
      {error && (
        <div style={{ background: "#ffebee", color: "#c62828", padding: "10px", marginBottom: "15px", borderRadius: "5px" }}>
          {error}
        </div>
      )}

      {step === "phone" ? (
        <form onSubmit={handleSendOtp} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <input
            type="text"
            placeholder="شماره موبایل (مثلا 09368596077)"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            style={{ padding: "12px", border: "1px solid #ccc", borderRadius: "5px", fontSize: "16px" }}
          />
          <button type="submit" disabled={loading} style={{ padding: "12px", background: "#007bff", color: "white", border: "none", borderRadius: "5px", cursor: "pointer", fontSize: "16px" }}>
            {loading ? "در حال ارسال..." : "ارسال کد"}
          </button>
        </form>
      ) : (
        <form onSubmit={handleVerifyOtp} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <p>کد به شماره <b>{phone}</b> ارسال شد.</p>
          {devCode && <p style={{ color: "green" }}>کد تست (چاپ شده توسط بک‌اند): {devCode}</p>}
          
          <input
            type="text"
            placeholder="کد ۴ رقمی را وارد کنید"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            style={{ padding: "12px", border: "1px solid #ccc", borderRadius: "5px", fontSize: "16px", textAlign: "center" }}
          />
          <button type="submit" disabled={loading} style={{ padding: "12px", background: "#28a745", color: "white", border: "none", borderRadius: "5px", cursor: "pointer", fontSize: "16px" }}>
            {loading ? "در حال بررسی..." : "ورود"}
          </button>
          <button type="button" onClick={() => setStep("phone")} style={{ padding: "12px", background: "#6c757d", color: "white", border: "none", borderRadius: "5px", cursor: "pointer" }}>
            اصلاح شماره
          </button>
        </form>
      )}
    </div>
  );
}